import { useQueryClient } from 'react-query';

import { usePost } from '../../utils/reactQuery';
import { ApiRoutesEnum } from '../../utils/routes';

export const useUpdateRecruitmentNote = () => {
  const queryClient = useQueryClient();
  return usePost({
    url: ApiRoutesEnum.recruitmentAddNote,
    onSuccess: () => {
      queryClient.invalidateQueries([ApiRoutesEnum.recruitmentAddNote]);
    },
  });
};
